var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinnyCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.833 5.853L8.888.5l.779.823L3.833 7.5l-3.5-3.706.778-.823 2.722 2.882z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/skinny-checkmark.svg";
export { SvgSkinnyCheckmark as ReactComponent };